<form #form novalidate (ngSubmit)="onSubmit()">
  <!-- TODO: Uncomment this when we use me/permissions  -->
  <!-- <div id="suggestionsDetailContainer"
    class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col"
    [ngClass]="{ 'openDetails': suggestion && !edit && roleService.permissions['USER']['READ'], 'openDetailsEdit': suggestion && edit && roleService.permissions['USER']['UPDATE'], 'expandedDetails': expanded}"> -->
  <div id="suggestionsDetailContainer" class="container absolute top-20 right-0 hiddenDetails w-0 h-[calc(100vh-75px)] overflow-hidden flex flex-col"
  [ngClass]="{ 'openDetails': suggestion || newSuggestion, 'expandedDetails': expanded}">
    <section class="topbar h-14 mt-4 flex items-center">
      <div class="mr-4 my-2 ml-6 justify-end ">
        <div class="flex main rounded-[50%] h-10 w-10 justify-center items-center"
          [ngClass]="{'hidden': !newSuggestion}">
          <div [ngClass]="{ 'block': steps.includes(1), 'hidden': !steps.includes(1), 'quarter1': numberSteps === 3, 'half1': numberSteps === 2 }"></div>
          <div [ngClass]="{ 'block': steps.includes(2), 'hidden': !steps.includes(2), 'quarter2': numberSteps === 3, 'half2': numberSteps === 2 }"></div>
          <div class="quarter3" [ngClass]="{ 'block': steps.includes(3), 'hidden': !steps.includes(3) }"></div>
          <label class="flex font-bold text-base primary-purple-text cutout justify-center items-center">
            {{ currentStep }}/{{ numberSteps }}
          </label>
        </div>
      </div>
      <div class="flex">
        @if (!newSuggestion) {
          <img [src]="getDetailIcon()" class="w-6 h-6" />
        }
        <h1 class="ml-2 text-xl font-semibold primary-purple-text">
          {{ literalService.get(`suggestions.${getDetailTitle()}`, true) }}
        </h1>
      </div>
      <section id="actions" class="flex ml-auto mr-8">
        <div class="flex items-center justify-center gap-2">
          @if (!newSuggestion && !edit) {
            @if (userType === CommunicationUserType.DRIVERS) {
              <img [src]="images.suggestions.conversation" alt="reply" class="h-6 w-6 cursor-pointer" (click)="openConversation()" [tooltip]="literalService.get('suggestions.tooltips.conversation', true)" [position]="TooltipPosition.BELOW" />
            }
            @if (suggestion?.userSuggester) {
              <img [src]="images.suggestions.messagesIcon" alt="messagesToUserSuggestion" class="h-6 w-6 cursor-pointer" (click)="goToUserMessages()" [tooltip]="literalService.get('suggestions.tooltips.messagesToUser', true)" [position]="TooltipPosition.BELOW" />
            }
            <img [src]="images.suggestions.edit" alt="editSuggestion" class="h-6 w-6 cursor-pointer" (click)="editAction($event)" [tooltip]="literalService.get('suggestions.tooltips.edit', true)" [position]="TooltipPosition.BELOW" />
          }
          <img [src]="images.close" alt="closeDetails" class="h-6 w-6 cursor-pointer" (click)="close()" [tooltip]="literalService.get('closeWindow', true)" [position]="TooltipPosition.BELOW" />
        </div>
      </section>
    </section>
    <section class="h-full !px-8 !pb-8 !pt-4 flex flex-col justify-between overflow-auto scrollable-content">
      <article id="body" class="pb-6">
        <div id="suggestionDetailForm" class="grid grid-flow-col gap-x-10">
          @for (element of suggestionForm; track element.id; ) {
            @if ((!edit && !newSuggestion) || !element.edit.editable) {
              @if (expanded ? true : !element.expanded) {
                <div class="mt-4"
                  [ngClass]="{'hidden': element.hidden, 'row-span-2': element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100}">
                  <app-detail
                    [data]="element"
                    [value]="element.value"
                    [extendable]="element.edit.inputType === InputType.LONG_TEXT && element.value.length >= 100" />
                </div>
              }
            }
            @else if (edit || newSuggestion) {
              @if (expanded ? true && !element.hidden: !element.expanded && !element.hidden) {
                <div class="mt-4 h-full" [ngClass]="{'row-span-2': element.edit.inputType === InputType.LONG_TEXT, 'hidden': element.hidden}">
                  <app-input
                    [data]="element"
                    [edit]="true"
                    [independent]="false"
                    [translateValue]="element?.translateValue"
                    [hasErrors]="invalid.includes(element.edit?.valueToChange)"
                    [error]="showError(element.value, element.edit?.valueToChange)"
                    (setEventEmitter)="changeData($event.value, element)"
                    (changeEventEmitter)="changeData($event.target, element)"
                    (scrollEventEmitter)="scroll($event)"
                    (searchEventEmitter)="search($event, element.edit?.valueToChange)"
                  />
                  @if (newSuggestion && element.title =='suggestions.data.user') {
                    <div class="pt-1 pb-2">
                      <label class="cursor-pointer flex items-center">
                        <input [id]="'checkbox'" type="checkbox" [checked]="anonymousUser" class="focus:ring-transparent mr-2 cursor-pointer" (change)="setAnonymousUser()" />
                        {{ literalService.get('suggestions.data.anonymousUser', true) }}
                      </label>
                    </div>
                  }
                </div>
              }
            }
          }
        </div>
      </article>
      @if (!newSuggestion) {
        <section class="flex items-center absolute right-5 top-0 bottom-0">
          <img alt="arrowToExpand" [src]="images.arrowLeft" class="h-5 w-5 cursor-pointer expand"
            [ngClass]="{'actionRotateArrowOpen': !expanded, 'actionRotateArrowClose': expanded}"
            (click)="expanded = !expanded" />
        </section>
      }
      @if (edit || newSuggestion) {
        <section class="flex mt-4 justify-center items-center">
          <div class="flex items-center w-full" [ngClass]="{'justify-start': !expanded, 'justify-end': expanded}">
            <input type="button"
              class="secondary gap-4 border-2 font-semibold h-14 w-36 uppercase mr-2.5 cursor-pointer"
              [value]="literalService.get(currentStep === 1 || edit ? 'cancel' : 'back')" (click)="currentStep === 1 || edit ? cancel($event) : goBack()" />
            <input type="button"
              class="primary text-white gap-4 border-2 font-semibold h-14 w-36 uppercase cursor-pointer"
              [disabled]="disabledSaveButton()"
              [value]="steps.includes(numberSteps) || edit ? literalService.get('save') : literalService.get('continue')"
              (click)="steps.includes(numberSteps) || edit ? onSubmit() : continue()" />
          </div>
        </section>
      }
      @else if (suggestion && expanded) {
        <div class="text-right mt-5 pb-8 pr-4">
          @if (suggestion.creatorName || suggestion.createdAt) {
            <p class="primary-purple-light-text font-light text-sm leading-5">{{ literalService.get('created', true) }}
              @if (suggestion.creatorName) {
              <span class="font-light text-sm">
                {{ literalService.get('by') }} {{ suggestion.creatorName}}
              </span>
              }
              {{ literalService.get('at') }} {{ utilsService.convertDate(suggestion.createdAt) | date: 'dd/MM/yyyy HH:mm' }}
            </p>
          }
          @if (suggestion.modifierName || suggestion.lastModifiedAt) {
            <p class="primary-purple-light-text font-light text-sm leading-5">{{ literalService.get('lastModification',
              true) }}
              @if (suggestion.modifierName) {
                <span class="font-light text-sm"> {{ literalService.get('by') }} {{ suggestion.modifierName }}</span>
              }
              {{ literalService.get('at') }} {{ utilsService.convertDate(suggestion.lastModifiedAt) | date: 'dd/MM/yyyy HH:mm'  }}
            </p>
          }
        </div>
      }
    </section>
  </div>
</form>

<app-modal-conversation [id]="'conversationModal'" [messages]="conversation" [receiverName]="suggestion?.creatorName" (action)="sendMessage($event)" (close)="closeConversation()"></app-modal-conversation>